import { render, staticRenderFns } from "./DDialog.vue?vue&type=template&id=466bb504&scoped=true&"
import script from "./DDialog.vue?vue&type=script&lang=js&"
export * from "./DDialog.vue?vue&type=script&lang=js&"
import style0 from "./DDialog.vue?vue&type=style&index=0&id=466bb504&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466bb504",
  null
  
)

export default component.exports